import { render } from "./CalendarConfiguration.vue?vue&type=template&id=3e16f309&scoped=true"
import script from "./CalendarConfiguration.vue?vue&type=script&lang=js"
export * from "./CalendarConfiguration.vue?vue&type=script&lang=js"

import "./CalendarConfiguration.vue?vue&type=style&index=0&id=3e16f309&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e16f309"]])

export default __exports__